(() => {
  const themeId = document.currentScript.dataset.liveThemeId;
  const origin = 'https://www.thegrainshop.com.au';
  function update(anchor) {
    const raw = anchor.getAttribute('href');
    if (!raw || raw.startsWith('#') || anchor.hasAttribute('data-fga-internal')) return;
    let url;
    try { url = new URL(raw, location.href); } catch { return; }
    const isGrain = /^(www\.)?thegrainshop\.com\.au$/.test(url.hostname);
    const localCatalog = url.origin === location.origin && /\/(products|collections)\//.test(url.pathname);
    if (!isGrain && !localCatalog) return;
    url.protocol = 'https:';
    url.host = new URL(origin).host;
    ['preview_theme_id', '_fd', 'pb', 'preview_key'].forEach(key => url.searchParams.delete(key));
    if (themeId) url.searchParams.set('preview_theme_id', themeId);
    if (anchor.href !== url.href) anchor.href = url.href;
    anchor.target = '_blank';
    anchor.rel = 'noopener';
  }
  function scan(root) {
    if (root.nodeType !== 1 && root !== document) return;
    if (root.matches?.('a[href]')) update(root);
    root.querySelectorAll('a[href]').forEach(update);
  }
  scan(document);
  new MutationObserver(records => records.forEach(record => {
    if (record.type === 'attributes') update(record.target);
    else record.addedNodes.forEach(scan);
  })).observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['href']});
})();
